
import { AssessmentQuestion } from "@/store/modules/recruiter/interfaces";
import Vue from "vue";
import PaginationControls from "@/components/shared/PaginationControls.vue";

export default Vue.extend({
  name: "QuestionsList",
  components: {
    PaginationControls
  },
  props: {
    questions: {
      type: Array as () => AssessmentQuestion[],
      default: () => []
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      limitOptions: [5, 10, 20, 50, 100]
    };
  },
  computed: {
    paginatedQuestions(): AssessmentQuestion[] {
      return this.questions;
    }
  },
  methods: {
    getQuestionNumber(index: number): number {
      return (this.page - 1) * this.limit + index + 1;
    },
    getQuestionTypeColor(type: string): string {
      switch (type) {
        case "mcq":
          return "blue";
        case "true_false":
          return "green";
        case "short_answer":
          return "orange";
        default:
          return "grey";
      }
    },
    getQuestionTypeLabel(type: string): string {
      switch (type) {
        case "mcq":
          return this.$t(
            "recruiter.assessments.questions_section.multiple_choice"
          ) as string;
        case "true_false":
          return this.$t(
            "recruiter.assessments.questions_section.true_false"
          ) as string;
        case "short_answer":
          return this.$t(
            "recruiter.assessments.questions_section.short_question"
          ) as string;
        default:
          return this.$t(
            "recruiter.assessments.questions_section.unknown"
          ) as string;
      }
    },
    onPageChange(page: number) {
      this.$emit("page-change", page);
    },
    onLimitChange(limit: number) {
      this.$emit("limit-change", limit);
    },
    getQuestionStatusLabel(isEnabled: boolean): string {
      return this.$t(
        isEnabled
          ? "recruiter.assessments.questions_section.enabled"
          : "recruiter.assessments.questions_section.disabled"
      ) as string;
    }
  }
});
